import React, { PureComponent } from "react";

import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";

import {
  sortNumeric,
  selectFormat,
  Error,
  getMetricForColumn,
} from "components/Utils/Utils.js";

import paginationFactory from "react-bootstrap-table2-paginator";

class WorldCupTables extends PureComponent {
  componentDidMount() {
    this.props.childRef(this);
  }

  renderTable = (data, columns) => {
    const { title } = this.props;
    data.forEach((d, i) => {
      d.id = i;
    });

    const table_columns = [
      {
        dataField: "game_number",
        text: "Match #",
        style: { width: "90px", minWidth: "90px" },
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "episode_title",
        text: "Episode",
        style: { minWidth: "200px", maxWidth: "200px", textAlign: "left" },
        headerAlign: "left",
        sort: true,
        filter: textFilter({
          getFilter: (filter) => filter,
          placeholder: " ",
          className: "custom-table-filter-input",
          caseSensitive: false,
        }),
      },
      {
        dataField: "view_starts",
        text: "View Starts",
        style: { width: "90px", minWidth: "90px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0.0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "brand_platform",
        text: "Brand Platform",
        style: { minWidth: "150px", maxWidth: "150px", textAlign: "left" },
        headerAlign: "left",
        sort: true,
        filter: textFilter({
          getFilter: (filter) => filter,
          placeholder: " ",
          className: "custom-table-filter-input",
          caseSensitive: false,
        }),
      },
      {
        dataField: "page",
        text: "Page",
        style: { minWidth: "320px", maxWidth: "320px", textAlign: "left" },
        headerAlign: "left",
        sort: true,
      },

      {
        dataField: "report_name",
        text: "Report Name",
        style: { minWidth: "180px", maxWidth: "180px", textAlign: "left" },
        headerAlign: "left",
        sort: true,
      },
      {
        dataField: "video_title",
        text: "Video Title",
        style: { minWidth: "320px", maxWidth: "320px", textAlign: "left" },
        headerAlign: "left",
        sort: true,
        filter: textFilter({
          getFilter: (filter) => filter,
          placeholder: " ",
          className: "custom-table-filter-input",
          caseSensitive: false,
        }),
      },
      {
        dataField: "unique_visitors",
        text: "Unique Visitors",
        style: { width: "130px", minWidth: "130px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0.0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "visits",
        text: "Visits",
        style: { width: "130px", minWidth: "130px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "views",
        text: "Views",
        style: { width: "70px", minWidth: "70px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "min_watched",
        text: "Min Watched",
        style: { width: "100px", minWidth: "100px" },
        formatter: getMetricForColumn,
        formatExtraData: { type: "number" },
        csvFormatter: (cell) =>
          selectFormat("number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "avg_view_time",
        text: "Avg View Time",
        style: { width: "110px", minWidth: "110px" },
        formatter: (cell, row) =>
          getMetricForColumn({ ...cell, type: "time" }, row),

        csvFormatter: (cell) => {
          return selectFormat("time", cell.value);
        },
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "avg_min_watched",
        text: "Avg Min Watched",
        style: { width: "110px", minWidth: "110px" },
        formatter: (cell, row) =>
          getMetricForColumn({ ...cell, type: "time" }, row),

        csvFormatter: (cell) => {
          return selectFormat("time", cell.value);
        },
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "highlight_video_seconds_watched",
        text: "Highlight Video Sec Watched",
        style: { width: "200px", minWidth: "200px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "highlight_start",
        text: "Highlight Start",
        style: { width: "200px", minWidth: "200px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
    ];

    const trClassFormat = (row) =>
      row.campaign
        ? "content-table-bar-chart__highlight"
        : "content-table-bar-chart__indent";

    const defaultSorted = [];
    const urlParams = new URLSearchParams(this.props.url);

    if (urlParams.has("sortby")) {
      // defines the filter according the URL
      defaultSorted.push({
        dataField: urlParams.get("sortby"),
        order: urlParams.get("order") || "desc",
      });
    }

    const filename = title.split(" ").join("_") || "spreadsheet";

    const columnsSorted = columns.map((columnName) =>
      table_columns.find((c) => c.dataField === columnName)
    );

    const paginationSize =
      [
        "dashboard/telemundo/world-cup-top-short-form-videos",
        "dashboard/telemundo/world-cup-top-videos?content_type=live&campaign=world-cup-2023",
        "dashboard/telemundo/world-cup-top-videos?content_type=replay&campaign=world-cup-2023",
        "dashboard/telemundo/world-cup-top-videos?content_type=live&campaign=world-cup-2022",
        "dashboard/telemundo/world-cup-top-videos?content_type=replay&campaign=world-cup-2022",
      ].filter((url) => this.props.url.includes(url)).length > 0
        ? 5
        : 15;

    const pagination = paginationFactory({
      sizePerPage: paginationSize,
      hideSizePerPage: true,
    });

    return (
      <>
        <ToolkitProvider
          keyField="id"
          data={data}
          columns={columnsSorted}
          rowClasses={trClassFormat}
          striped={false}
          hover={true}
          bordered={false}
          exportCSV={{
            fileName: filename + ".csv",
            exportAll: false,
            onlyExportFiltered: true,
          }}
        >
          {(props) => (
            <BootstrapTable
              {...props.baseProps}
              {...props.csvProps}
              pagination={this.props.pagination ? pagination : undefined}
              defaultSorted={defaultSorted}
              ref={(el) => (this.childRef = el)}
              filter={filterFactory()}
            />
          )}
        </ToolkitProvider>
      </>
    );
  };

  builtInExportCSV = () => this.childRef;

  render() {
    const { data, columns, title } = this.props;
    const widgetsToDisplayMessage = [
      "Top Livestreams Yesterday",
      "Top Replays Yesterday",
    ];

    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }

    return widgetsToDisplayMessage.indexOf(title) > -1 &&
      data.data.length === 0 ? (
      <div className="row">
        <div className="mt-5">
          <p className="world-cup-no-matches">
            There is no match data for this day.
          </p>
        </div>
      </div>
    ) : (
      this.renderTable(data.data, columns)
    );
  }
}

export default WorldCupTables;
